<div class="verify">
  <h1 class="verify__title">Phone Number Verification</h1>

  <div class="verify__content">
    <div class="verify__notification">
      <div class="verify__notification__icon">
        <span nz-icon nzType="ng-zorro:iphone"></span>
      </div>
      <p class="verify__message">We’ve Sent You A Notification</p>
      <span class="verify__instruction"
        >Please check your SMS inbox to verify your phone number.</span
      >
    </div>

    <p class="verify__sub-instruction" (click)="goToChangePhone()">
      Please enter your verification code.
      <a class="verify__help-link">Need to update your phone number?</a>
    </p>

    <div class="verify__code-inputs">
      <nz-input-number
        *ngFor="let digit of codeArray; let i = index"
        #codeInput
        class="verify__input"
        [nzMax]="9"
        [nzMin]="0"
        [ngModel]="digit"
        [maxlength]="1"
        (keydown)="onKeydown($event, i)"
        [nzDisabled]="codeArray[i - 1] === null"
      ></nz-input-number>
    </div>

    <div class="verify__actions">
      <a class="verify__actions__resend-link" (click)="resendCode()">Resend Code</a>

      <button nz-button nzType="primary" class="verify__actions__submit-btn" (click)="submitForm()">
        Submit
      </button>
    </div>
  </div>

  <p class="verify__note">
    * You will receive a verification code via SMS if you have access to the
    number. The verification code is valid for 10 minutes. You can request a new
    code via "Resend Code."
    <br />
    <br />
    <br />
    Standard SMS charges may apply. If you don't verify within 3 hours, your
    account will be deleted.
  </p>
</div>
